import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ISetHubSizes } from './set-hub-sizes';

import { HttpHelper } from '../../../shared/http-helper';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

@Injectable()
export class SetHubSizesService {

    //need to have this somewhere besides hardcoded in here
    //private _setHubSizesSaveUrl = `http://localhost:55706/api/systemmanagement/SetHubSizes`;
    private _setHubSizesSaveUrl = `api/systemmanagement/SetHubSizes`;
 
    constructor(private  httpHelper: HttpHelper) { }

    getSetHubSizesResponse(): Observable<ISetHubSizes> {
         return this.httpHelper.get(`${this._setHubSizesSaveUrl}`)
            // .map((response: Response) => <ISetHubSizes> response.json())
           //  .do(data => console.log('Set Hub Sizes service: ' +  JSON.stringify(data)))
           //  .catch(this.handleError);
    }

   
    private handleError(error: Response) {
         // in a real world app, we may send the server to some remote logging infrastructure
         // instead of just logging it to the console
                 
         console.error(error);
         return Observable.throw(error.json().error || 'Server error');
    }
}


/** WEBPACK FOOTER **
 ** ./app/system-management/growth-rates/set-hub-sizes/set-hub-sizes.service.ts
 **/